import InputBox from "src/business-types/grocery/components/InputBox";

type InputGroupProps = {
  label: string;
  type: string;
  value: string;
  name: string;
  onChange: (name: string, value: string) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  mandatory?: boolean;
  disabled?: boolean;
  error?: boolean;
};

const InputGroup: React.FC<InputGroupProps> = ({ label, type, value, name, onChange, onKeyDown, mandatory = false, disabled, error }) => (
  <div className='flex flex-col gap-1'>
    <div className='flex'>
      <label className='text-sm font-medium text-gray-700'>{label}</label>
      {mandatory && <p className='text-red-600'>*</p>}
    </div>
    <InputBox
      type={type}
      value={value}
      onKeyDown={onKeyDown}
      onChange={(e) => onChange(name, e.target.value)}
      maxLength={type === "number" ? 12 : 40}
      disabled={disabled}
      error={error}
    />
  </div>
);

export default InputGroup;
